import React from 'react';
import * as PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from "@material-ui/core/FormControl";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import {withStyles} from "@material-ui/core";
import HeatExchangerCollapseListItem from "./HeatExchangerCollapseListItem";
import HeatExchangerInAddMenu from "./HeatExchangerInAddMenu";
import PlantManagementUtility from "./PlantManagementUtility";
import Utility from "../../Utility";

const styles = theme => ({
    root: {
        minWidth: 200
    },
    listItemWrapper: {
        margin: theme.spacing.unit
    },
    select: {
        margin: theme.spacing.unit,
        minWidth: 200,
    }
});

export class HeatExchangerAddMenu extends React.Component {
    constructor(props) {
        super(props);

        let notPlanningHeatExchangerArray = PlantManagementUtility.getHeatExchangerArrayFilterByNotPlaningOrderByAsc(this.props.heatExchangerArray);
        let defaultSelectedHeatExchanger = null;
        if (notPlanningHeatExchangerArray.length > 0) {
            defaultSelectedHeatExchanger = notPlanningHeatExchangerArray[0];
        }

        this.state = {
            searchKeyWord: '',
            isOpenSelectAddNoPlanHeatExchangerDialog: false,
            selectedHeatExchanger: defaultSelectedHeatExchanger,
        };

        this.closeDialog = this.closeDialog.bind(this);
        this.onChangeSearchKeyWord = this.onChangeSearchKeyWord.bind(this);
        this.onChangeSelectApparatusMachineNumber = this.onChangeSelectApparatusMachineNumber.bind(this);
        this.onClickAdd = this.onClickAdd.bind(this);
        this.onClickCancelAdd = this.onClickCancelAdd.bind(this);
        this.onClickDecideAdd = this.onClickDecideAdd.bind(this);
        this.updateSelectValue = this.updateSelectValue.bind(this);
    }

    closeDialog() {
        this.setState({isOpenSelectAddNoPlanHeatExchangerDialog: false});
    }

    onChangeSearchKeyWord(e) {
        this.setState({searchKeyWord: e.target.value});
    }

    onChangeSelectApparatusMachineNumber(e) {
        this.setState({selectedHeatExchanger: e.target.value});
    }

    onClickAdd() {
        this.setState({isOpenSelectAddNoPlanHeatExchangerDialog: true});
    }

    onClickCancelAdd() {
        this.closeDialog();
    }

    onClickDecideAdd() {
        this.setState({isOpenSelectAddNoPlanHeatExchangerDialog: false}, () => {
            let newHeatExchanger = Utility.getDeepCopy(this.state.selectedHeatExchanger);
            newHeatExchanger.systemInfoAdditionalFlag = PlantManagementUtility.PARAM_BOOL.TRUE; // 追加熱交フラグ.
            this.props.onClickDecideAddNoPlanHeatExchanger(newHeatExchanger);
        });
    }

    updateSelectValue() {
        let notPlanningHeatExchangerArray = PlantManagementUtility.getHeatExchangerArrayFilterByNotPlaningOrderByAsc(this.props.heatExchangerArray);
        let defaultSelectedHeatExchanger = null;
        if (notPlanningHeatExchangerArray.length > 0) {
            defaultSelectedHeatExchanger = notPlanningHeatExchangerArray[0];
        }
        this.setState({selectedHeatExchanger: defaultSelectedHeatExchanger});
    }

    static isItemHidden(searchKeyWord, apparatus, machineNumber) {
        let replacedSearchKeyWord = Utility.replaceAlphanumericToHalfWidthLowerAlphanumeric(searchKeyWord);
        let replacedApparatusAndMachineNumber = Utility.replaceAlphanumericToHalfWidthLowerAlphanumeric(apparatus + machineNumber); // 「装置機番」で部分一致を判定する.

        if (searchKeyWord === '') {
            return false;
        }

        // noinspection RedundantIfStatementJS
        if (replacedApparatusAndMachineNumber.indexOf(replacedSearchKeyWord) !== -1) {
            return false;
        }

        return true;
    }

    render() {
        const {heatExchangerArray, classes} = this.props;
        const noPlanHeatExchangerArray = PlantManagementUtility.getHeatExchangerArrayFilterByNotPlaningOrderByAsc(heatExchangerArray);
        const planingHeatExchangerArray = PlantManagementUtility.getHeatExchangerArrayFilterByPlaningOrderByAsc(heatExchangerArray);
        const groupByApparatusArray = PlantManagementUtility.getGroupByApparatusArrayOrderByAsc(planingHeatExchangerArray);
        return (
            <div className={classes.root}>
                <div className={classes.listItemWrapper}>
                    <Button
                        disabled={noPlanHeatExchangerArray.length === 0}
                        onClick={this.onClickAdd}
                        variant="contained"
                        color="primary"
                        fullWidth
                    >
                        追加
                    </Button>
                </div>
                <div className={classes.listItemWrapper}>
                    <TextField
                        label="検索キーワード"
                        variant="outlined"
                        value={this.state.searchKeyWord}
                        onChange={this.onChangeSearchKeyWord}
                    />
                </div>
                {this.state.searchKeyWord === '' ?
                    <List>
                        {Object.keys(groupByApparatusArray).map((row, i) => {
                            return (
                                <HeatExchangerCollapseListItem
                                    key={i}
                                    groupKey={row}
                                    groupHeatExchangerArray={groupByApparatusArray[row]}
                                    onClickHeatExchanger={this.props.onClickHeatExchanger}
                                />
                            )
                        })}
                    </List>
                    :
                    <div>
                        {planingHeatExchangerArray.map((row, i) => {
                            return (
                                <HeatExchangerInAddMenu
                                    heatExchanger={row}
                                    onClick={this.props.onClickHeatExchanger}
                                    key={i}
                                    className={classes.listItemWrapper}
                                    hidden={HeatExchangerAddMenu.isItemHidden(this.state.searchKeyWord, row.instrumentApparatus, row.instrumentMachineNumber)}
                                />
                            )
                        })}
                    </div>
                }
                <Dialog
                    open={this.state.isOpenSelectAddNoPlanHeatExchangerDialog}
                    onClose={this.closeDialog}
                    onEnter={this.updateSelectValue}
                >
                    <DialogTitle>装置機番を選択</DialogTitle>
                    <DialogContent>
                        <FormControl variant="outlined">
                            <Select
                                onChange={this.onChangeSelectApparatusMachineNumber}
                                className={classes.select}
                                value={this.state.selectedHeatExchanger}
                            >
                                {noPlanHeatExchangerArray.map((row, i) => {
                                    return (
                                        <MenuItem key={i} value={row}>
                                            {row.instrumentApparatus + row.instrumentMachineNumber}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onClickCancelAdd} color="secondary" variant="contained"> キャンセル</Button>
                        <Button onClick={this.onClickDecideAdd} color="primary" variant="contained">決定</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

HeatExchangerAddMenu.propTypes = {
    heatExchangerArray: PropTypes.array.isRequired,
    onClickDecideAddNoPlanHeatExchanger: PropTypes.func.isRequired,
    onClickHeatExchanger: PropTypes.func.isRequired,
};

export default withStyles(styles)(HeatExchangerAddMenu);
